module.exports = __webpack_public_path__ + "img/we-logo.a502427b.png";